var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBackCommunity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/General/Cross") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.8313351,29.0700348 L36.1152097,23.7861539 C36.6015968,23.2997663 36.6015968,22.5111783 36.1152097,22.0248603 C35.6288227,21.5384727 34.8403052,21.5384727 34.3539182,22.0248603 L29.0699739,27.3088107 L23.7860296,22.0247907 C23.2996426,21.5384031 22.5111251,21.5384031 22.0247381,22.0247907 C21.5384206,22.5111783 21.5384206,23.2997663 22.0247381,23.7860843 L27.3086823,29.0699652 L22.0247381,34.3539157 C21.5384206,34.8403033 21.5384206,35.6288913 22.0247381,36.1152093 C22.5111251,36.6015969 23.2996426,36.6015969 23.7860296,36.1152093 L29.0699739,30.8312588 L34.3539182,36.1152093 C34.8402356,36.6015969 35.6288227,36.6015969 36.1152097,36.1152093 C36.6015968,35.6288217 36.6015968,34.8403033 36.1152097,34.3539157 L30.8313351,29.0700348 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travel-plan-details",
    transform: "translate(-22.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/General/Cross",
    transform: "translate(1.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#333333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 58 0 58 58 0 58"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackCommunity);
export default __webpack_public_path__ + "static/media/icBackCommunity.79e323f684c14d30cd7a2c7cd0dd52a5.svg";
export { ForwardRef as ReactComponent };